import type { MapLayerState, MapLayerActions } from "@/types/stores/map";

export function createStaticLayerActions(
  set: any,
  get: () => MapLayerState & MapLayerActions
) {
  return {
    setStaticLayerVisibility: (layerId: string, isVisible: boolean) => {
      set(
        (state: MapLayerState) => ({
          staticLayers: {
            ...state.staticLayers,
            [layerId]: isVisible,
          },
        }),
        false,
        "map/setStaticLayerVisibility"
      );
    },

    toggleStaticLayer: (layerId: string) => {
      const state = get();
      const newValue = !state.staticLayers[layerId];
      get().setStaticLayerVisibility(layerId, newValue);
    },
  };
}

